import React, { PropTypes } from 'react';
import classnames from 'classnames';

export default class Button extends React.Component {
  static propTypes = {
    link: PropTypes.string,
    color: PropTypes.string,
    children: PropTypes.node,
    size: PropTypes.string,
    icon: PropTypes.string,
    block: PropTypes.bool,
    blank: PropTypes.bool,
  };

  render() {
    const { link, color, children, size, icon, block, blank } = this.props;
    let iconElement = null;

    const styles = {
      wrapper: classnames({
        button: true,
        'button--red': (color === 'primary') || (color === 'red'),
        'button--green': (color === 'secondary') || (color === 'green'),
        'button--white': color === 'white',
        'button--small': size === 'small',
        'button--medium': size === 'medium',
        'button--big': size === 'big',
        'button--huge': size === 'huge',
        'button--block': block,
      }),
      icon: classnames('fa', `fa-${icon}`),
    };

    if (icon) {
      iconElement = <i className={styles.icon}></i>;
    }

    return (
      <a href={link} target={blank ? '_blank' : '_self'} className={styles.wrapper}>{iconElement}<span>{children}</span></a>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/Button.jsx
 **/